module.exports = __webpack_public_path__ + "static/media/Medalha-Prata.b3011c74.svg";